import { FormElement } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";

import { ComponentId } from "./enums";
import { selectFormData } from "./summary.selectors";
import {
  setOCVehicleCorrectnessAgreement,
  setOCVehicleContactAgreement,
} from "./summary.slice";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  selector: selectFormData,
  //JIRA LPPLWEBMOB-721
  //redirect: Url.OC_VEHICLE_SENDING,
  redirect: Url.OC_VEHICLE,
  content: [
    {
      title: "Zgody",
      sections: [
        {
          id: "ac-summary-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.CORRECTNESS_AGREEMENT,
              onChange: setOCVehicleCorrectnessAgreement,
              label: "",
              marketingLabel: "zobacz zgody",
              items: [
                {
                  label: "Potwierdzam poprawność wprowadzonych danych",
                  value: "true",
                },
              ],
              required: true,
            },
          ],
        },
        {
          id: "ac-summary-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.CONTACT_AGREEMENT,
              onChange: setOCVehicleContactAgreement,
              label: "",
              marketingLabel: "zobacz zgody",
              items: [
                {
                  label: "Wyrażam zgodę na kontakt w celu likwidacji szkody",
                  value: "true",
                },
              ],
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
